import "./style.css";

export default class NewsAndEventsDetail {
  static selector = ".news-and-events-detail";

  constructor(block) {
    this.block = block;
  }
}
